class loggingUtil {
    /**
     * Get the required Kibana tags for making a proper panel with metrics
     * @param startTime
     * @param serviceName
     * @param method
     * @param statusCode
     * @param extraTags
     * @returns {{responseTime: number, service: void, http_status: number, http_q_status: string, http_method: *}}
     */
    static getKibanaTags(startTime, serviceName, method, statusCode, extraTags = {}) {
      const httpStatus = parseInt(statusCode, 10);
  
      return {
        responseTime: Date.now() - startTime,
        service: serviceName,
        http_status: httpStatus, // Must be integer.
        http_q_status: `${httpStatus.toString().charAt(0)}XX`,
        http_method: method,
        ...extraTags,
      };
    }
  }
  
  module.exports = loggingUtil;